import { Box, Grid, Paper } from '@mui/material'

import { CardTitle } from 'components/common/controls'

import FilterCriteriaForm from './FilterCriteriaForm'
import StatusCategoryFilter from './StatusCategoryFilter'

const BookingFilter = () => {
  return (
    <Box p={2}>
      <Grid container columnSpacing={3} rowSpacing={2}>
        <Grid item xs={12} md='auto' alignSelf='center'>
          <StatusCategoryFilter />
        </Grid>

        <Grid item xs={true}>
          <Paper variant='outlined'>
            <Grid p={2}>
              <CardTitle>Filter Criteria</CardTitle>
              <FilterCriteriaForm />
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  )
}

export default BookingFilter
